import styled from 'styled-components';

export const HiddenTooltip = styled.div`
  &.hidden {
    display: none;
  }
`;
